// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';

export enum SigningMode {
  LOCAL = 'LOCAL',
}

export interface ModuleState {
  activeParty: string;
  activeSigningMode: SigningMode;
}

export const ModuleContext = React.createContext<ModuleState | undefined>(undefined);

export const useModule = () => {
  const context = React.useContext(ModuleContext);
  if (!context) {
    throw new Error('useModule must be used within a ModuleProvider');
  }
  return context;
};

export const useModuleParty = () => {
  const { activeParty } = useModule();
  return activeParty;
};
